/* AUTH */
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const CLEAR_USER_STATE = "CLEAR_USER_STATE";
export const CHECK_CLAIMS = "CHECK_CLAIMS";
export const CHECK_CLAIMS_SUCCESS = "CHECK_CLAIMS_SUCCESS";
export const CHECK_CLAIMS_ERROR = "CHECK_CLAIMS_ERROR";
export const USEREDIT_SUCCESS = "USEREDIT_SUCCESS";
export const USEREDIT_ERROR = "USEREDIT_ERROR";
export const USER_GRANT_ADMIN_SUCCESS = "USER_GRANT_ADMIN_SUCCESS";
export const USER_GRANT_ADMIN_ERROR = "USER_GRANT_ADMIN_ERROR";

/* POST */
export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
export const CREATE_POST_ERROR = "CREATE_POST_ERROR";
export const EDIT_POST_SUCCESS = "EDIT_POST_SUCCESS";
export const EDIT_POST_ERROR = "EDIT_POST_ERROR";
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS";
export const DELETE_POST_ERROR = "DELETE_POST_ERROR";

/* POST EDIT */
export const SET_EDITED_LANGUAGE = "SET_EDITED_LANGUAGE"
export const SET_LINKED_URL = "SET_LINKED_URL" //part of url hack

/* STATIC POST LOADING */
export const LOAD_NEXT_FIVE_POSTS = "LOAD_NEXT_FIVE_POSTS"
export const LOAD_PREVIOUS_FIVE_POSTS = "LOAD_PREVIOUS_FIVE_POSTS"